// This is needed to remove the hover state on mobile
window.addEventListener('touchstart', function() {});
